import { AppConfigModel } from '@/models/app/app-config';


/**
 *
 * This App Config serializer is responsible for converting the Raw format to model.
 *
 */
export class AppConfigSerializer {
  private static INSTANCE = new AppConfigSerializer();

  static get instance() {
    return this.INSTANCE;
  }

  public appConfigModelSerializer(res: any) {
    const result: AppConfigModel = {
      api_endpoint_url: res.api_endpoint_url,
      product_url: res.product_url,
      is_stage_drill_down: res.is_stage_drill_down,
      demo_tenant: res.demo_tenant,
      guest_account: res.guest_account ? res.guest_account : null,
      NON_K12_HIERARCHY_USERS_KEY: res.NON_K12_HIERARCHY_USERS_KEY,
      DEMO_USER_LIST: res.DEMO_USER_LIST,
      TENANTS_IDS: res.TENANTS_IDS,
      SHOWCASE_DEMO_USERS: res.SHOWCASE_DEMO_USERS,
      SHOWCASE_LEARNERS_LIST: res.SHOWCASE_LEARNERS_LIST,
      DEMO_TENANT_USERS: res.DEMO_TENANT_USERS,
      IS_LEARNING_CHALLENGE: res.IS_LEARNING_CHALLENGE,
      CONTENT_PROVIDER_LIST: res.CONTENT_PROVIDER_LIST,
      hiddenMenus: res.hiddenMenus,
      IS_SHOWCASE_ENABLE: res.IS_SHOWCASE_ENABLE,
      LOGO_URL: res.LOGO_URL,
      IS_IMPACT_STATUS_ENABLE: res.IS_IMPACT_STATUS_ENABLE,
      IS_SHOW_IMPACT: res.IS_SHOW_IMPACT,
      tenantUrl: res.tenantUrl,
      adminUiAppId: res.adminUiAppId,
      S3_BUCKET_ASSETS_BASE_PATH: res.S3_BUCKET_ASSETS_BASE_PATH,
      STATIC_IMAGE_URL: res.STATIC_IMAGE_URL,
      loginPageInfo: res.loginPageInfo,
      cdnUrl: res.cdnUrl,
      nudgeInfo: res.nudgeInfo,
      reportUserType: res.reportUserType,
      myGooruInsightsJsCdn: res.myGooruInsightsJsCdn,
    };
    return result;
  }

  public appPermissionSerializer(res: any, permission: any) {
    let isEnableResearchPage: boolean = false;
    const userRole: any = {
      menus: [],
      pages: {},
    };
    if (permission && permission.length && res) {
      permission.map((pageAccess: any) => {
        Object.keys(res).map((menuPages) => {
          if (!userRole.pages.hasOwnProperty(menuPages)) {
            userRole.pages[menuPages] = [];
          }
          Object.keys(res[menuPages]).map((pages) => {
                if (res[menuPages][pages].indexOf(pageAccess) !== -1) {
                  isEnableResearchPage = pages === 'research-view';
                  if (userRole.menus.indexOf(menuPages) === -1
                          && (pages === `${menuPages}-view` || pages === 'all')) {
                    userRole.menus.push(menuPages);
                  }
                  if (userRole.pages[menuPages].indexOf(pages) === -1) {
                     userRole.pages[menuPages].push(pages);
                  }
                }
            });
        });
      });
    }
    userRole.landingPage = isEnableResearchPage
      ? 'projects' : (userRole.menus.indexOf('network') !== -1 ? '/network' :  '/' + userRole.menus[0]);
    return userRole;
  }
}

export const appConfigSerializer = AppConfigSerializer.instance;
